import client from "./axiosConfig";

export const getAllGRNs = (params) => {
    const config = {
        url: `/inventory/GoodReceiveNote/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const createGRNService = (data) => {
    const config = {
        url: `/inventory/GoodReceiveNote/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const getAllGRNMaterials = (params) => {
    const config = {
        url: `/inventory/GRNMaterial/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const getGRNByID = (id) => {
    const config = {
        url: `/inventory/GoodReceiveNote/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
}

export const updateGRNByID = (id,data) => {
    const config = {
        url: `/inventory/GoodReceiveNote/${id}/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
}

export const deleteGRNByID = (id) => {
    const config = {
        url: `/inventory/GoodReceiveNote/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}
